import { useLocation } from 'react-router-dom';

export default function useIsUserPages(): boolean {
  const { pathname } = useLocation();
  return pathname.startsWith('/minasidor');
}
